import { Map } from '@okletsplay/core';
import React, { FC, memo } from 'react';

interface MapFormatProps {
  map?: Map | unknown;
}

const MAP_LABELS: Record<Map, string> = {
  [Map.HowlingAbyss]: 'Howling Abyss',
  [Map.SummonersRift]: 'Summoners Rift',
};

const MapFormatComponent: FC<MapFormatProps> = ({ map }) => {
  if (!map) {
    return null;
  }

  return <>{MAP_LABELS[map as Map]}</>;
};

export const MapFormat = memo(MapFormatComponent);
